import { topicGroups } from "@/mocks/scandal";

const groupIcon = ["ri-shopping-bag-3-line", "ri-scales-3-line", "ri-chat-voice-line", "ri-line-chart-line", "ri-shield-check-line"];

export default function TopicsWall() {
  return (
    <section id="topics" className="border-b border-background-200/70 bg-background-100/50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2">
            <span className="inline-block h-4 w-1.5 rounded-sm bg-accent-500" />
            <span className="text-xs font-bold uppercase tracking-widest text-accent-600">Topic Wall</span>
          </div>
          <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">话题墙 · 按类目找瓜</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            抖音黑料涉及的类别很多。先把它们按「带货争议、抄袭对比、言论翻车、数据注水、平台处理」分好堆，
            想看哪类点哪堆，每个标签都能链回对应整理好的时间线。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {topicGroups.map((g, gi) => (
            <div
              key={g.name}
              className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${groupIcon[gi % groupIcon.length]} text-lg`} />
                </span>
                <h3 className={`text-[15px] font-bold ${g.color}`}>{g.name}</h3>
                <span className="ml-auto text-[11px] text-foreground-400">{g.tags.length} 个标签</span>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {g.tags.map(([label, count]) => (
                  <a
                    key={label}
                    href="#timeline"
                    className="group inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700 whitespace-nowrap transition-colors hover:border-accent-400 hover:bg-accent-50 hover:text-accent-800"
                  >
                    {label}
                    <span className="rounded-full bg-background-200 px-1.5 text-[10px] font-bold text-foreground-500 group-hover:bg-accent-200 group-hover:text-accent-800">
                      {count}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          ))}

          {/* 占位说明卡 */}
          <div className="flex flex-col justify-center rounded-lg border border-dashed border-background-300 bg-background-50 p-5">
            <i className="ri-archive-stack-line text-2xl text-secondary-500" />
            <h3 className="mt-3 text-[15px] font-bold text-foreground-900">还有别的类目？</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              类目与标签持续扩充中，新分类会同步接入对应时间线，保持条目顺手好找。
            </p>
            <a href="#archive" className="mt-3 inline-flex w-fit items-center gap-1 text-xs font-semibold text-accent-700 hover:text-accent-800">
              查看全部归档
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}